import { useLayoutEffect } from 'react'

const getScrollParent = (
  element: Element | null | undefined,
): Element | null | undefined => {
  let node = element

  while (node && !isScrollable(node)) {
    node = node.parentElement
  }

  return node || document.scrollingElement || document.documentElement
}

const isScrollable = (element: Element): boolean => {
  let style = window.getComputedStyle(element)
  return /(auto|scroll)/.test(
    style.overflow + style.overflowX + style.overflowY,
  )
}

const preventScroll = () => {
  let scrollable: Element | null | undefined
  let lastY: number = 0
  const scrollX = window.pageXOffset
  const scrollY = window.pageYOffset

  const handleTouchStart = (event: TouchEvent) => {
    if (event.target instanceof Element) {
      scrollable = getScrollParent(event.target)

      if (
        scrollable === document.documentElement &&
        scrollable === document.body
      ) {
        return
      }
    }

    lastY = event.changedTouches[0].pageY
  }

  const handleTouchMove = (event: TouchEvent) => {
    if (!scrollable) {
      return
    }

    if (
      scrollable === document.documentElement ||
      scrollable === document.body
    ) {
      event.preventDefault()
      return
    }

    const y = event.changedTouches[0].pageY
    const scrollTop = scrollable.scrollTop
    const bottom = scrollable.scrollHeight - scrollable.clientHeight

    if ((scrollTop <= 0 && y > lastY) || (scrollTop >= bottom && y < lastY)) {
      event.preventDefault()
    }

    lastY = y
  }

  const handleWindowScroll = () => {
    window.scrollTo(scrollX, scrollY)
  }

  if (document.documentElement) {
    const clientWidth = document.documentElement.clientWidth
    const scrollbarWidth = window.innerWidth - clientWidth
    document.documentElement.style.overflow = 'hidden'
    document.documentElement.style.paddingRight = `${scrollbarWidth}px`
  }

  document.addEventListener('touchstart', handleTouchStart, {
    passive: false,
    capture: true,
  })
  document.addEventListener('touchmove', handleTouchMove, {
    passive: false,
    capture: true,
  })
  window.addEventListener('scroll', handleWindowScroll)
  return () => {
    if (document.documentElement) {
      document.documentElement.style.overflow = ''
      document.documentElement.style.paddingRight = ''
    }

    document.removeEventListener('touchstart', handleTouchStart, {
      // @ts-ignore
      passive: false,
      capture: true,
    })
    document.removeEventListener('touchmove', handleTouchMove, {
      // @ts-ignore
      passive: false,
      capture: true,
    })
    window.removeEventListener('scroll', handleWindowScroll)
    window.scrollTo(scrollX, scrollY)
  }
}

export default function usePreventScroll(enabled: boolean) {
  useLayoutEffect(() => {
    if (enabled) {
      return preventScroll()
    }
  }, [enabled])
}
